import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-infinite-progress',
  templateUrl: './infinite-progress.component.html',
  styleUrls: ['./infinite-progress.component.scss']
})
export class InfiniteProgressComponent implements OnInit {
  constructor() { }

  ngOnInit() {  }
}